<script setup lang="ts">
defineProps({
    title: { type: String, required: true },
});
</script>

<template>
    <div class="flex flex-col gap-1.5">
        <h2 class="text-highlighted text-xl font-bold">{{ title }}</h2>
        <slot />
    </div>
</template>
